export default __webpack_public_path__ + "static/media/ic-art-blood-pressure.66f351f6.svg";